import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["data-qe-id"]
const _hoisted_2 = {
  key: 0,
  class: "internal"
}
const _hoisted_3 = {
  key: 1,
  class: "layout-wrap"
}
const _hoisted_4 = { class: "zone-tournament-image-cont" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "zone-tournament-info-wrapper" }
const _hoisted_7 = { class: "zone-tournament-info" }
const _hoisted_8 = { class: "tournament-title" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "tournament-info-layout" }
const _hoisted_11 = { class: "tournament-button-container" }
const _hoisted_12 = {
  key: 2,
  class: "layout-wrap"
}
const _hoisted_13 = { class: "zone-tournament-image-cont" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "zone-tournament-info-wrapper" }
const _hoisted_16 = { class: "zone-tournament-info" }
const _hoisted_17 = { class: "no-tournament" }
const _hoisted_18 = { class: "tournament-button-container" }

import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store'
import { TOURNAMENT_TYPE, TournamentTypeToName } from '@/model/TournamentType'
import { ZoneSelectionUi } from '@/model/ZoneSelection'
import { TournamentStatus } from '@/model/TournamentStatus'
import CTournamentInfo from '@/components/CTournamentInfo.vue'
import CLobbyStatus from '@/components/CLobbyStatus.vue'
import CTournamentStatusIndicator from '@/components/CTournamentStatusIndicator.vue'
import { isInternal } from '@/store/lib/util'
import { jslog } from '@gd/jslog'
import { TournamentUi } from '@/model/Tournament'


export default /*@__PURE__*/_defineComponent({
  __name: 'CZoneTournamentItem',
  props: {
    language: { default: 'en' },
    zoneSelectionUi: {}
  },
  emits: ['onGoToZone'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const router = useRouter()
const store = useStore()
const { t } = useI18n()

const logosAvailableForLocales = ['de', 'nl', 'fr']
/**
 * TODO replace this by the real name from i18n
 */
function tournamentTypeName(TOURNAMENT_TYPE: TOURNAMENT_TYPE) {
  return TournamentTypeToName[TOURNAMENT_TYPE]
}

const loadImage = computed(() => {
  let logo
  try {
    logo = require(`@/assets/logos/${tournamentInfo.value.image}.png`)
  } catch (err: unknown) {
    jslog.send({ error: new Error(`Unable to load logo ${tournamentInfo.value.image}.png`) })
  }
  return logo
})

const zoneLogo = computed(() => {
  if (
    props.zoneSelectionUi.zoneId === TOURNAMENT_TYPE.SKA_TOURNAMENT &&
    isInternalZone(props.zoneSelectionUi.tournamentType)
  ) {
    return require(`@/assets/zone-overview/internal/skat_matze.png`)
  }

  return require(`@/assets/zone-overview/${props.zoneSelectionUi.zoneId}${logoLocale.value}.png`)
})

const qeIdRoot = computed(() => {
  return `zone-tournament-item-${tournamentTypeName(props.zoneSelectionUi.tournamentType)}`
})

const buttonCaption = computed(() => {
  return t(`zoneSelection.zone.button_${props.zoneSelectionUi.zoneId}`)
})
// TODO vue3 - the object is completely different from what is expected in "c-tournament-info"
const tournamentInfoUi = computed((): TournamentUi => {
  const tournamentInfoUi = props.zoneSelectionUi.tournamentInfo
  return {
    ...tournamentInfoUi,
    metaData: {
      totalWin: tournamentInfoUi.totalWin,
      numberOfTickets: 0,
      entryFee: '0',
      restartFee: '0',
      playersPerGame: 0,
      numberOfGames: 0,
      roundsPerGame: 0,
      rejoinsUnlimited: false,
      rejoinsRemaining: 0,
      clearancePhase: false,
      distributionSchema: '',
      gameTechs: [],
      image: '',
    },
    tournamentStatus: props.zoneSelectionUi.tournamentStatus,
  } as any
})

const tournamentInfo = computed(() => {
  return props.zoneSelectionUi.tournamentInfo
})

const logoLocale = computed(() => {
  return props.zoneSelectionUi.zoneId === TOURNAMENT_TYPE.ROM_TOURNAMENT &&
    logosAvailableForLocales.indexOf(props.language) !== -1
    ? `_${props.language}`
    : ''
})

function enterZone() {
  emit('onGoToZone', props.zoneSelectionUi.tournamentType)
}

function isInternalZone(id: string) {
  return isInternal(id)
}

function onLobbyTimerComplete() {
  store.dispatch('fetchZoneTeasers').catch((err: any) => {
    if (err === 401) {
      router.replace('/extern/login')
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_t_button = _resolveComponent("t-button")!

  return (_openBlock(), _createElementBlock("section", {
    class: "zone-tournament-item",
    "data-qe-id": qeIdRoot.value
  }, [
    (isInternalZone(_ctx.zoneSelectionUi.tournamentType))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Internal"))
      : _createCommentVNode("", true),
    (tournamentInfo.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(`zone-tournament-image ${_ctx.zoneSelectionUi.zoneId}`)
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: zoneLogo.value,
                class: "image-inner",
                alt: "...no image"
              }, null, 8, _hoisted_5)
            ])
          ], 2),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.zoneSelectionUi.tournamentStatus !== _unref(TournamentStatus).FINISHED)
                ? (_openBlock(), _createBlock(CLobbyStatus, {
                    key: 0,
                    timers: _ctx.zoneSelectionUi.lobbyTimers,
                    onLobbyTimerComplete: onLobbyTimerComplete
                  }, null, 8, ["timers"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                (!_ctx.zoneSelectionUi.isMasters && tournamentInfo.value.image)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: loadImage.value
                    }, null, 8, _hoisted_9))
                  : _createCommentVNode("", true),
                _createElementVNode("h3", null, _toDisplayString(tournamentInfo.value.name), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(CTournamentInfo, {
                  "tournament-ui": tournamentInfoUi.value,
                  class: "tournament-info-box",
                  competitionDate: "",
                  registrationDate: "",
                  totalWin: ""
                }, null, 8, ["tournament-ui"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_t_button, {
                onClick: enterZone,
                yellow: "",
                m: "",
                "data-qe-id": "button-enter"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(buttonCaption.value), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(CTournamentStatusIndicator, {
            status: _ctx.zoneSelectionUi.tournamentStatus,
            "data-qe-id": "tournament-status"
          }, null, 8, ["status"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", {
            class: _normalizeClass(`zone-tournament-image ${_ctx.zoneSelectionUi.zoneId}`)
          }, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("img", {
                src: zoneLogo.value,
                class: "image-inner",
                alt: "...no current tournament"
              }, null, 8, _hoisted_14)
            ])
          ], 2),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("h3", _hoisted_17, _toDisplayString(_ctx.$t('zoneSelection.zone.noTournamentsPlanned')), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_t_button, {
                onClick: enterZone,
                yellow: "",
                m: "",
                "data-qe-id": "button-enter"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(buttonCaption.value), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]))
  ], 8, _hoisted_1))
}
}

})